export default "__VITE_ASSET__DbB6aS3O__"